import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle, withStateHandlers } from 'recompose'

import { isEqual, getPaginationObject } from 'utils/misc'
import withMixpanel, { INVITE_ADMIN_SUCCESS, SCREEN_VIEW_SETTINGS_ADMINISTRATION } from 'utils/mixpanel'

import * as toastModule from 'modules/toast'
import * as peopleModule from 'modules/people'
import * as popoverModule from 'modules/popover'
import * as userActions from 'actions/userActions'
import * as organisationModule from 'modules/organisation'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.user),
        users: idx(state, _ => _.people.approved),
        tableLoading: idx(state, _ => _.people.loading),
        organisation: idx(state, _ => _.organisation.selected),
      }
    },
    (dispatch) => {
      const actions = {
        ...toastModule,
        ...userActions,
        ...peopleModule,
        ...popoverModule,
        ...organisationModule
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      bulkSelected: false,
      selectedPeople: [],
      filters: {
        search: [{ key: 'fullName', value: null }],
        filter: [{key: 'role', value: 'ADMIN'}, {key: 'approved', value: true}],
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
      }
    }),
    {
      onPageChange: state => (offset) => {
        return getPaginationObject(state, { offset }, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    onInviteAdminClick: ({ track, organisation, actions }) => () => {
      actions.showPopover(popoverModule.INVITE_ADMIN, {
        onSubmit: (values) => {
          actions.sendAdminInvitation(organisation, values, () => {
            track(INVITE_ADMIN_SUCCESS)
            actions.hidePopover()
            actions.showToast(toastModule.SUCCESS_TOAST, 'Invitation Sent!')
          })
        }
      })
    },
    onSearchChange: ({ setFilters }) => (value) => {
      setFilters({ search: [{ key: 'fullName', value }] })
    },
    onTableSortClick: ({ setFilters }) => (orderBy) => {
      setFilters({orderBy: [orderBy]})
    },
    onBackPress: props => () => {
      props.history.goBack()
    },
    onTableSelectableClick: ({ 
      user, users, organisation, filters, setPagination, actions, history
    }) => (selectedUser) => {
      const isYou = selectedUser.id === user.id

      if (!users || Object.keys(users).length <= 1) {
        actions.showPopover(popoverModule.DELETE_ADMIN_BLOCKED, {
          hideCloseButton: true,
          onConfirm: () => {
            actions.hidePopover()
          }
        })
      } else {
        actions.showPopover(popoverModule.DELETE_ADMIN_CONFIRM, {
          user: selectedUser,
          onConfirm: () => {
            actions.deletePeople(organisation, [selectedUser.id], () => {
              actions.hidePopover()
              if (isYou) {
                history.push('/account/home')
              }
              else {
                actions.getPeople(organisation, filters, setPagination)
              }
            })
          },
        })
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      const { 
        track, actions, organisation, filters, setPagination
      } = this.props
      
      track(SCREEN_VIEW_SETTINGS_ADMINISTRATION)
      actions.getPeople(organisation, filters, setPagination)
    },
    componentDidUpdate(prevProps) {
      const { 
        actions, organisation, filters, setPagination
      } = this.props

      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getPeople(organisation, filters, setPagination)
      }
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/organisation/AdministrationOverview/AdministrationOverview.enhancer.js